import React from 'react';
import Navbar from '../components/Navbar';
import { Card, CardContent } from '../components/ui/card';
import { Phone, MapPin, Building2 } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-slate-900 mb-8 text-center" style={{ fontFamily: 'Outfit' }}>
          Contact
        </h1>

        <Card className="border border-slate-200 shadow-sm mb-8">
          <CardContent className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="flex flex-col items-center text-center space-y-3" data-testid="contact-phone">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                  <Phone className="w-8 h-8 text-blue-900" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>
                    Telefon
                  </h3>
                  <a
                    href="tel:0775536450"
                    className="text-blue-900 hover:text-blue-700 font-semibold"
                    style={{ fontFamily: 'IBM Plex Sans' }}
                  >
                    0775 536 450
                  </a>
                </div>
              </div>

              <div className="flex flex-col items-center text-center space-y-3" data-testid="contact-address">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
                  <MapPin className="w-8 h-8 text-orange-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>
                    Adresă
                  </h3>
                  <p className="text-slate-700" style={{ fontFamily: 'IBM Plex Sans' }}>
                    București
                    <br />
                    Sector 3
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center text-center space-y-3" data-testid="contact-company">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                  <Building2 className="w-8 h-8 text-green-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>
                    Date Firmă
                  </h3>
                  <p className="text-slate-700 font-mono text-sm" style={{ fontFamily: 'IBM Plex Sans' }}>
                    CUI RO51747672
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="flex flex-col items-center justify-center py-12 space-y-4">
          <img src="/logo.png" alt="TUNA FOOD BBD" className="h-40 w-auto" data-testid="contact-logo" />
          <p
            className="text-2xl font-semibold text-blue-900 text-center"
            style={{ fontFamily: 'Outfit' }}
            data-testid="contact-slogan"
          >
            Furnizorul tău în HoReCa
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
